import {Button, Chip} from "omoplay";
import {useMemo, useState} from "react";
import {convertFilter} from "../../constants/filters";


const TreeChoiceForm = ({isSingle = false, targetFilters, selectedTargetFilters, onChangeFilter, onChangeTargetFilters}) => {
    // 방어: 저장된 filters 가 객체/undefined 등 비배열로 들어오면 selectedTargetFilters.map 에서 크래시 → 배열로 정규화
    if (!Array.isArray(selectedTargetFilters)) selectedTargetFilters = []
    if (!Array.isArray(targetFilters)) targetFilters = []
    const [onActiveFilter, setActiveFilter] = useState(selectedTargetFilters.map((item) => item.value) ?? []);

    const addItem = (children, item, parent = null) => {
        const updateValue = [...selectedTargetFilters];
        const existIndex = updateValue.findIndex(
            (item) => item.value === children.value
        );
        const selectedIndex = selectedTargetFilters.findIndex(filter => filter.value === item.label + " " + children.label)
        if (existIndex > -1 || selectedIndex > -1) return;

        updateValue.push({
            category: parent ? parent.value : item.value,
            value: children.value,
            label: parent ? item.label + " " + children.label : children.label,
        });
        onChangeTargetFilters(convertFilter(updateValue));
    };

    const handleChangeFilter = (depth, value) => {
        const updateValue = [...onActiveFilter];
        updateValue[depth - 1] = value;

        if (depth > 1) {
            targetFilters.filter((parent) => parent.value === updateValue[0]).forEach((parent) => {
                parent.data
                    .filter((item) => item.value === updateValue[1])
                    .forEach((item) => {
                        if (item.data && item.data.length > 0) {
                            item.data
                                .filter((children) => children.value === updateValue[2])
                                .forEach((children) => {
                                    if (isSingle) {
                                        selectedTargetFilters = []
                                    }
                                    addItem(children, item, parent);
                                });
                        } else {
                            addItem(item, parent);
                        }
                    });
            });
        }
        else if (depth <= onActiveFilter.filter(filter =>  filter != null).length && depth < 3) {
            const cancels = []
            for (let i = 0; i < onActiveFilter.length - depth; i++) {
                cancels.push(onActiveFilter[depth + i])
            }
            updateValue.forEach((item, index) => {
                if (cancels.includes(item)) {
                    updateValue.splice(index, 1)
                }
            })

            const selectedUpdateValue = [...selectedTargetFilters];
            const selectedCancels = []

            if (selectedUpdateValue.length > 0) {
                for (let i = 0; i < Math.abs(selectedUpdateValue.length - depth); i++) {
                    selectedCancels.push(selectedUpdateValue[Math.abs(selectedUpdateValue.length - depth) - 1 + i].value)
                }
            }

            selectedUpdateValue.forEach((item, index) => {
                if (selectedCancels.includes(item.value)) {
                    selectedUpdateValue.splice(index, 1);
                }
            })
            onChangeTargetFilters(convertFilter(selectedUpdateValue).reduce((acc, item) => {
                const key = item.category;
                const value = item.value;

                if (!acc[key]) {
                    acc[key] = [];
                }

                acc[key].push(value);
                return acc;
            }, {}));

        }
        setActiveFilter(updateValue);
    };

    const filterCategories = useMemo(() => {
        if (selectedTargetFilters) {
            return Array.from(new Set(selectedTargetFilters.map((item) => item.category)));
        }
    }, [selectedTargetFilters]);

    const cancelItem = (value, depth = null) => {
        const updateValue = [...selectedTargetFilters];
        const removeIndex = updateValue.findIndex((item) => item.value === value);
        if (removeIndex > -1) {
            updateValue.splice(removeIndex, 1);
            onChangeTargetFilters(convertFilter(updateValue).reduce((acc, item) => {
                const key = item.category;
                const value = item.value;

                if (!acc[key]) {
                    acc[key] = [];
                }

                acc[key].push(value);
                return acc;
            }, {}));
        }

        if (depth != null && onActiveFilter[depth - 1] === value) {
            const updateValue = [...onActiveFilter];
            updateValue[depth - 1] = null;
            setActiveFilter(updateValue);
        }
    };

    return (
        <div className="pt-[8px]">
            <div className="border-gray-200 bg-gray-100 border">
                <div className="flex divide-x border-gray-200">
                    <div className="w-1/3 h-full">
                        <ul className="flex-col gap-2 flex p-4 overflow-auto max-h-[298px]">
                            {targetFilters.map((item) => {
                                let disabled = item.value === "" ? "disabled" : ""
                                const isActive =
                                    onActiveFilter[0] === item.value ||
                                    selectedTargetFilters.find((target) => target.value === item.value) !== undefined;

                                return (
                                    <Button variants={isActive ? "primary" : "outlined"} value={item.label}
                                            icon={<div></div>}
                                            onClick={() => {
                                                if (!disabled) {
                                                    handleChangeFilter(1, item.value)
                                                    onChangeFilter?.(1, item.value)
                                                }
                                            }} />
                                );
                            })}
                        </ul>
                    </div>
                    <div className="w-1/3 h-full">
                        <ul className="flex-col gap-2 flex p-4 overflow-auto max-h-[298px]">
                            {targetFilters.filter((item) => item.value === onActiveFilter[0] ||
                                selectedTargetFilters.find((target) => target.value === item.value) !== undefined).map((item) =>
                                item.data.map((item) => {
                                    const isActive = onActiveFilter[1] === item.value ||
                                        selectedTargetFilters.find((target) => target.value === item.value) !== undefined;
                                    return (
                                        <Button variants={isActive ? "primary" : "outlined"} value={item.label}
                                                icon={<div></div>}
                                                onClick={() => {
                                                    handleChangeFilter(2, item.value)
                                                    onChangeFilter?.(2, item.value)
                                                }} />
                                    );
                                })
                            )}
                        </ul>
                    </div>
                    <div className="w-1/3 h-full">
                        <ul className="flex-col gap-2 flex p-4 overflow-auto max-h-[298px]">
                            {targetFilters.map((item) => {
                                return item.data
                                    .filter((item) => item.value === onActiveFilter[1])
                                    .map((parent) =>
                                        parent.data?.map((item) => {
                                            //FIXME 동일한 value 처리
                                            const isActive = selectedTargetFilters.some(filter => {
                                                return filter.label === parent.label + " " + item.value
                                            })
                                            return (
                                                <Button variants={isActive ? "primary" : "outlined"} value={item.label}
                                                        icon={<div></div>}
                                                        onClick={() => {
                                                            handleChangeFilter(3, item.value)
                                                            onChangeFilter?.(3, item.value)
                                                        }} />
                                            );
                                        })
                                    )
                                }
                            )}
                        </ul>
                    </div>
                </div>
            </div>
            {
                !isSingle && (
                    <div className="flex-col p-4 gap-4">
                        {filterCategories &&
                            filterCategories.map((value) => {
                                const categoryIndex = targetFilters.findIndex((parent) => parent.value === value);

                                return (
                                    <div className="flex gap-4">
                                        <div className="flex-align-center font-semibold">
                                            {targetFilters[categoryIndex]?.label}
                                        </div>
                                        <ul className="flex gap-4 flex-wrap">
                                            {selectedTargetFilters
                                                .filter((item) => item.category === value)
                                                .map((item) => {
                                                    return (
                                                        <Chip size="large" className="font-bold" closeable onClose={() => cancelItem(item.value)}>{item.label}</Chip>
                                                    );
                                                })}
                                        </ul>
                                    </div>
                                );
                            })}
                    </div>
                )
            }
        </div>
    )
}

export default TreeChoiceForm